__turbopack_context__.v({
  "crumbItem": "BreadCrumbs-module__LO1tQW__crumbItem",
  "crumbText": "BreadCrumbs-module__LO1tQW__crumbText",
  "wrapper": "BreadCrumbs-module__LO1tQW__wrapper",
});
